if (!customElements.get("filter-drawer")) {
  class FilterDrawer extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle() {
      this.classList.toggle("is-open");
    }

    disconnectedCallback() {
      document.removeEventListener(
        "facets-drawer:toggle",
        this.handleToggleRef
      );
    }

    connectedCallback() {
      document.addEventListener("facets-drawer:toggle", this.handleToggleRef);
    }
  }

  customElements.define("filter-drawer", FilterDrawer);
}
